 import { gql } from "apollo-boost"
 
 export const createFormF50 = gql`
   mutation createFormF50($data: CreateFormF50Input) {
    CreateFormF50(data: $data)
  }
 `

 export const updateFormF50 = gql`
   mutation updateFormF50Status($data: UpdateFormF50StatusInput!) {
    updateFormF50Status(data: $data)
  }
 `

 export const updateConsultantStatus = gql`
 mutation updateConsultantStatus($data: UpdateConsultantStatusInput!) {
  updateConsultantStatus(data: $data)
}`